import "./App.css";
import ContactForm from "./Components/Contact";
import Intro from "./Components/Intro";
import KnowMore from "./Components/KnowMore";
import Projects from "./Components/Projects";
import { useEffect, useState } from "react";

function App() {
	const [theme, setTheme] = useState({});

	useEffect(() => {
		const theme = localStorage.getItem("theme");
		if (theme === "blue") {
			setTheme(blueStyle);
		} else if (theme === "green") {
			setTheme(greenStyle);
		} else if (theme === "purple") {
			setTheme(purpleStyle);
		} else if(theme === "default") {
			setTheme(defaultStyle);
		}
	}, []);

	function setDefault() {
		localStorage.setItem("theme", "default");
		setTheme(defaultStyle);
	}
	function setBlue() {
		localStorage.setItem("theme", "blue");
		setTheme(blueStyle);
	}
	function setGreen() {
		localStorage.setItem("theme", "green");
		setTheme(greenStyle);
	}
	function setPurple() {
		localStorage.setItem("theme", "purple");
		setTheme(purpleStyle);
	}

	const defaultStyle = {
		"--mainColor": "#eaeaea",
		"--secondaryColor": "#fff",
		"--borderColor": "#c1c1c1",
		"--mainText": "black",
		"--secondaryText": "#4b5156",
		"--themeDotBorder": "#24292e",
		"--previewBg": "rgb(251,249,243,0.8)",
		"--perviewShadow": "#f0ead6",
		"--buttonColor": "black",
	};
	const blueStyle = {
		"--mainColor": "#15202b",
		"--secondaryColor": "#192734",
		"--borderColor": "#164D56",
		"--mainText": "#fff",
		"--secondaryText": "#eeeeee",
		"--themeDotBorder": "#fff",
		"--previewBg": "rgb(25,39,52,0.8)",
		"--perviewShadow": "#111921",
		"--buttonColor": "#17a2b8",
	};
	const purpleStyle = {
		"--mainColor": "#46344E",
		"--secondaryColor": "#382a3f",
		"--borderColor": "#1d1520",
		"--mainText": "#fff",
		"--secondaryText": "#eeeeee",
		"--themeDotBorder": "#fff",
		"--previewBg": "rgb(29,21,32,0.8)",
		"--perviewShadow": "#2b202f",
		"--buttonColor": "#8534a3",
	};
	const greenStyle = {
		"--mainColor": "#606B56",
		"--secondaryColor": "#515a48",
		"--borderColor": "#161914",
		"--mainText": "#fff",
		"--secondaryText": "#eeeeee",
		"--themeDotBorder": "#fff",
		"--previewBg": "rgb(81,90,72,0.8)",
		"--perviewShadow": "#2a2f25",
		"--buttonColor": "#669966",
	};

	return (
		<div style={theme}>
			<Intro
				setDefault={setDefault}
				setBlue={setBlue}
				setPurple={setPurple}
				setGreen={setGreen}
			/>
			<KnowMore />
			<Projects />
			<ContactForm />
		</div>
	);
}

export default App;
